import { ElementType, MouseEvent } from 'react';

import { IconArrowLeft } from '@tabler/icons-react';
import { IconButton } from '@mui/material';

import { isModifiedClick } from '../../utils/common/history';
import useBackNavigation from '../../utils/react/hooks/useBackNavigation';

export interface BackButtonProps {
  /** The page above this one, followed when there is nothing behind to go back to. */
  href?: string;
  /** The icon button to draw, so each header keeps its own styling. */
  button?: ElementType;
  /** Accessible name, where the control reads as something other than back. */
  label?: string;
}

/**
 * A header's leading back button, absent until given somewhere to go. It stays
 * an anchor to the parent page, so it can be opened in a new tab and previewed
 * on hover, while a plain click prefers the entry behind it in history.
 */
const BackButton = ({ href, button: Button = IconButton, label = 'Back' }: BackButtonProps) => {
  const goBack = useBackNavigation();

  if (!href) {
    return null;
  }

  return (
    <Button
      aria-label={label}
      href={href}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        if (isModifiedClick(event)) {
          return;
        }
        event.preventDefault();
        goBack(href);
      }}
    >
      <IconArrowLeft />
    </Button>
  );
};

export default BackButton;
